/// <reference path="../../app.definition.ts" />

import * as angular from "angular";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";
import { ProjectType } from "@common/model/projectType";
import { Util } from "@common/util";

export interface IProjectTypeService {
    getProjectTypes();
    getProjectTypesNames();
}

export class ProjectTypeService implements IProjectTypeService {
    static $inject = ["$q", "CacheService", "ApiAdapterService"];

    constructor(private $q,
        private $_cache: CacheService,
        private $_api: JavaApiAdapterService) {
    }

    // gets the team role
    getProjectTypes() {
        var deferred = this.$q.defer();
        let projectTypes = Util.getProjectTypes();
        if (!!projectTypes && projectTypes.length > 0) {
            deferred.resolve(projectTypes);
        } else {
            this.$_api.getProjectTypes().then(
                (data) => {
                    var types = [];

                    for (var index in data) {
                        types.push(new ProjectType().deserialize(data[index]));
                    }

                    types = types.sort(
                        (a, b) => {
                            return (!!a.name) ? a.name.toLowerCase().localeCompare((!!b.name) ? b.name.toLowerCase() : '') : ((!!b.name) ? b.name.toLowerCase() : '');
                        }
                    );

                    types = types.filter(function (type) {
                        return !!type.name;
                    });

                    Util.setProjectTypes(types);
                    deferred.resolve(types);
                }, (e) => {
                    deferred.reject(e)
                });
        }
        return deferred.promise;

    }

    getProjectTypesNames() {
        var deferred = this.$q.defer();
        this.getProjectTypes().then((s) => {
            var arr = Util.projectTypes.sort(
                (a, b) => {
                    return (!!a.name) ? a.name.toLowerCase().localeCompare(b.name.toLowerCase()) : a.name;
                }
            );

            var typeNames = [];

            for (var i = 0; i < arr.length; i++) {
                typeNames.push(arr[i].name);

            }

            typeNames.push('Other');
            deferred.resolve(typeNames);
        }, (e) => {
            deferred.reject(e)
        });
        return deferred.promise;
    }
}

angular.module('eCareVault.common.services')
    .service('ProjectTypeService', ProjectTypeService);
